unit GlobalWeb;

interface

uses System.Classes, System.Generics.Collections, System.SysUtils, Vcl.Graphics;

Function Get_Monat_By_Nr( iMonat : Integer ) : String ;
Function Get_WoTag_By_Nr( sWoTag : String ) : String ;

Function IToB( aInteger : Integer ) : Boolean  ;
function BToI( aBool : Boolean ) : Integer ;

 Function BToS( bWert : Boolean ) : String;
 Function SToB( sWert : String ) : Boolean;
 Function SToI( sWert : String ) : Integer;
 Function SToF( sWert : String ) : Double;
 Function SToC( sWert : String ) : TColor;
 Function DToS( dtDatum : TDateTime ) : String;

[async] function Crypt(const s: string): string; async;


type
   TParam = Class
     Integer1 : Integer;
     Integer2  : Integer;
     Integer3  : Integer;
     Integer4  : Integer;
     String1 : String;
     String2 : String;
     String3 : String;
     Datum1  : Double;
     Datum2  : Double;
     Tabelle : String;
     ID_Fahrzeug : Integer;
     ID_Tour     : Integer;
     ID_Tau      : Integer;
     ID_Mab      : Integer;
   End;

 type
   TCoreObj = Class
     ID          : Integer ;
     Bezeichnung : String  ;
     Wert : Double;
     Tag  : Double;
   End;

type
   TCoreGuiObj = Class
     ID          : Integer ;
     Bezeichnung : String  ;
   End;

type
   TCoreFzgObj = Class
     ID          : Integer ;
     Bezeichnung : String  ;
     Nummer      : String;
   End;

type
   TObjAbfKon = Class
     KENNUNG : Integer ; // 1 - GRP1     2 - GRP2     3 - PKT
     BEZEICHNUNG : String;
     BezeichParent : String;
     ID_GRP1 : Integer;
     ID_GRP2 : Integer;
     ID_PKT  : Integer;
     FzgKennung : Integer;
     FehlerText : String;
     FehlerBilder : Integer;
     BilderDaten : Array[1..20] of String ;
     BilderName  : Array[1..20] of String ;
     NOK : Boolean;
   End;



var
  g_ID_MandLand : Integer;
  g_DokuOrdner  : String;
  g_BildOrdner  : String;

const
  DENCRYPT1 = 1;
  cH = chr(39);

  c_ImgVorsatz =  'data:image/png;base64,' ;


implementation


//================================================================================================//

function Crypt(const s: string): string;
var i: integer;
begin
  result := s;
  for i := 1 to length(s) do
    case ord(s[i]) of
    ord('A')..ord('M'),ord('a')..ord('m'): result[i] := chr(ord(s[i])+13);
    ord('N')..ord('Z'),ord('n')..ord('z'): result[i] := chr(ord(s[i])-13);
    ord('0')..ord('4'): result[i] := chr(ord(s[i])+5);
    ord('5')..ord('9'): result[i] := chr(ord(s[i])-5);
    end;
end;

//================================================================================================//

Function Get_Monat_By_Nr( iMonat : Integer ) : String ;
Begin

 Result := 'unbekannt' ;

 Case iMonat of
    1 : Result := 'Januar' ;
    2 : Result := 'Februar';
    3 : Result := 'März'   ;
    4 : Result := 'April'  ;
    5 : Result := 'Mai'    ;
    6 : Result := 'Juni'   ;
    7 : Result := 'Juli'   ;
    8 : Result := 'August' ;
    9 : Result := 'September' ;
   10 : Result := 'Oktober'   ;
   11 : Result := 'November'  ;
   12 : Result := 'Dezember'  ;
 End;

End;

//================================================================================================//

Function Get_WoTag_By_Nr( sWoTag : String ) : String ;
Begin

  If      sWoTag = '1' then Result := 'Mo'
  Else If sWoTag = '2' then Result := 'Di'
  Else If sWoTag = '3' then Result := 'Mi'
  Else If sWoTag = '4' then Result := 'Do'
  Else If sWoTag = '5' then Result := 'Fr'
  Else If sWoTag = '6' then Result := 'Sa'
  Else If sWoTag = '7' then Result := 'So';


End;

//====================================================================================================================//

function IToB( aInteger : Integer ) : Boolean  ;
begin
  If aInteger = 1 then Result := True Else Result := False ;
end;

//====================================================================================================================//

function BToI( aBool : Boolean ) : Integer ;
begin
  If aBool then Result := 1 Else Result := 0 ;
end;

//====================================================================================================================//

 Function DToS( dtDatum : TDateTime ) : String;
 begin

   Result := cH+DateTimeToStr(dtDatum)+cH

 end;

//====================================================================================================================//

 Function BToS( bWert : Boolean ) : String;
 begin
  If bWert then Result := '1'
  Else Result := '0';
 end;

 Function SToB( sWert : String ) : Boolean;
 begin
  If sWert='1' then
       Result := True
  Else Result := False;
 end;

//====================================================================================================================//

Function SToI( sWert : String ) : Integer;
Begin
   If sWert='' then sWert := '0';
   Result := StrToIntDef(sWert,0);
End;

//====================================================================================================================//

Function SToF( sWert : String ) : Double;
Begin

  If sWert='' then sWert := '0';

  Try
    Result := StrToFloat(sWert);
  Except

  End;

End;

//====================================================================================================================//

Function SToC( sWert : String ) : TColor;
var sFarbe : String;
begin

  sFarbe := sWert;
  If sFarbe='' then sFarbe := 'clWhite';

  Try
    Result := StringToColor( sFarbe );
  Except
    Result := clWhite;
  End;

end;


end.
